/**
 * Support Request API service.
 * Wraps the clinic portal support-requests endpoint.
 */

import { apiClient } from '@/shared/lib/axios';
import { clinicApiPath } from '@/shared/lib/apiPath';
import type { SupportRequestFormData } from '@/schemas/supportRequestSchema';

interface ApiResponse {
  success: boolean;
  message?: string;
  data?: unknown;
}

/**
 * Send a support request email via the clinic portal API.
 *
 * `serviceType` reflects the A2/R2 mode currently shown to the user (from
 * ThemeContext). The backend uses it to build the subject prefix 【Ａ2】/【Ｒ2】.
 */
export async function sendSupportRequest(
  siteType: string,
  clinicNumber: string,
  data: SupportRequestFormData,
  serviceType: 'A2' | 'R2'
): Promise<ApiResponse> {
  const response = await apiClient.post<ApiResponse>(
    clinicApiPath(siteType, clinicNumber, '/support-requests'),
    { ...data, service_type: serviceType }
  );
  return response.data;
}
